exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{margin:0;padding:0;width:100%;height:100%;background-size:cover;background-position:top;font:14px/1.5 tahoma,arial,Hiragino Sans GB,\\\\5B8B\\4F53,sans-serif;-webkit-font-smoothing:antialiased;font-weight:300}", "", {"version":3,"sources":["D:/workspace/yuping/ypxf/yuping-view/src/components/Login.vue"],"names":[],"mappings":"AACA,KACE,SAAS,AACT,UAAU,AACV,WAAW,AACX,YAAY,AAEX,sBAAuB,AACxB,wBAAwB,AACxB,mEAAuE,AACvE,mCAAoC,AACpC,eAAiB,CAClB","file":"Login.vue","sourcesContent":["\nbody {\n  margin:0;\n  padding:0;\n  width:100%;\n  height:100%;\n  /* background:url(\"../assets/images/loginbg.png\"); */\n   background-size: cover;\n  background-position:top;\n  font: 14px/1.5 tahoma,arial,'Hiragino Sans GB','\\5b8b\\4f53',sans-serif;\n  -webkit-font-smoothing: antialiased;\n  font-weight: 300;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-28a249d8","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Login.vue
// module id = 1243
// module chunks = 0